import React, { useMemo } from 'react';
import { Alert, List, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

import { Store } from '../../../codegen/graphql';
import { getRestrictedAdvertisingZoneStores } from '../../../helpers/storeSelectionHelper';
import When from '../../common/When';

type RestrictedStoresNoticeProps = {
    advertisingZoneStores: Store[] | null | undefined;
};

function RestrictedStoresNotice({
    advertisingZoneStores,
}: RestrictedStoresNoticeProps) {
    const restrictedStores = useMemo(
        () => getRestrictedAdvertisingZoneStores(advertisingZoneStores),
        [advertisingZoneStores],
    );

    return (
        <When condition={restrictedStores.length > 0}>
            <Alert
                icon={<IconAlertTriangle size={16} />}
                color="orange"
                variant="light"
                title={`${restrictedStores.length} store(s) excluded - restricted SKU`}
            >
                <Text size="sm" className="mb-2">
                    These stores cannot receive this price change and will be
                    skipped when it is sent to SAP.
                </Text>
                <List size="sm" spacing={2}>
                    {restrictedStores.map(store => (
                        <List.Item key={store.id}>
                            {store.storeNo} {store.name} -{' '}
                            {store.priceChangeRestriction?.reason}
                        </List.Item>
                    ))}
                </List>
            </Alert>
        </When>
    );
}

export default RestrictedStoresNotice;
